import { Outlet } from "react-router-dom";
import Page from "../../components/PageWrapper";

export default function RevenuesOutlet() {
    return (
        <Page title="Revenues">
            <Outlet />
        </Page>
    )
}